<template>
<div>
<ContentHeader title="Videolar"  url="CreateEducationpackVideo" :show_button="true" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="videos.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>
<template v-else>

<DraggableContentTable :data="videos" :columns="columns" routename="EducationpackVideo" deleteobjectname="educationvideo" @dataDeleted="getData" @listupdated="listupdated" name_parameter="name" route_param="video_id" :show_index="true"></DraggableContentTable>



</template>






</template>



</div>	
</template>

<script>
export default {

  name: 'EducationpackVideos',
  data () {
    return {
      videos:[],
      loading:true,
      columns:[
      {
        type:"text",
        field:"name",
        header:"İsim",
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
  	this.getData()
  },
  computed:
  {
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.getData()
  		}
  	}
  },
  methods:{
  	async getData()
    {
        this.videos = await this.generalApiGetWithoutLoader("educationpack/videos/"+this.$route.params.id)
        console.log(this.videos)
        this.loading = await false
    },  
    listupdated(data)  
    {
    	console.log(data)
    	let formdata = new FormData()
    	formdata.append('list', JSON.stringify(data));
    	this.generalSubmission(formdata,"educationpack/reorder_videos/"+this.$route.params.id,this.afterlistupdated)
    },
    afterlistupdated(response)
    {
    	console.log(response.data)
    	this.videos = response.data
    },
  }
}
</script>

<style lang="css" scoped>
</style>